// export const imgBaseUrl='https://img.gkzyydt.com/upload/img/logo/';
export const imgBaseUrl='https://img.zy1dt.com/upload/img/logo/';
// export const xiaoguoBaseUrl='https://img.gkzyydt.com/upload/img/xiaoguo/';
export const xiaoguoBaseUrl='https://img.zy1dt.com/upload/img/xiaoguo/';